import { Box, Typography } from "@mui/material";
import { PRODUCT_LIST } from "../../constants/lang";
import getCurrentproductCount from "../../utils/commonFuntions";

const { products: productLabel } = PRODUCT_LIST;

export const renderProductInfo = (products = [], pageDetails, title = []) => {
  if (!products.length) return null;

  return (
    <>
        <Box className="info">
            <Box className="info-content">
            <Typography className="lexend-text" sx={{ textAlign: 'center' }}>{title}</Typography>
            <Typography className="product-count">
              {`${getCurrentproductCount(pageDetails)}/${pageDetails?.total_count} ${productLabel}`}
            </Typography>
            </Box>
        </Box>
    </>
  );
};
